/* TinyWolf dog saving (sections/tw-dog-sync.liquid). Sends quiz dogs to the Supabase function save-dog, which saves them
   on the Shopify customer (metafield tinywolf.dogs).
   - Plan builder: when a plan is ready, sends that dog. Logged in: signed customer id. Logged out with an email: the email.
     Supabase answers saved / created / login_required, and we show a short note under the plan.
   - My dogs (logged in): sends the dogs saved on this device that aren't on the account yet, then reloads once. */
(function () {
  var el = document.querySelector('[data-tw-dogsync]');
  if (!el || window.twDogSync) return;
  window.twDogSync = true;
  var cfg = {};
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg.url || !cfg.key) return;

  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var DONE = 'tw_dogsync_done';
  function done() { try { var l = JSON.parse(sessionStorage.getItem(DONE) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function markDone(ids) { try { sessionStorage.setItem(DONE, JSON.stringify(done().concat(ids).slice(-30))); } catch (e) {} }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function send(body) {
    return fetch(cfg.url.replace(/\/$/, '') + '/functions/v1/' + (cfg.fn || 'save-dog'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', apikey: cfg.key, Authorization: 'Bearer ' + cfg.key }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error('save-dog ' + r.status + ' ' + (j.error || '')); return j; }); });
  }
  function signed() { return cfg.cid && cfg.ts && cfg.sig ? { customer_id: String(cfg.cid), ts: String(cfg.ts), sig: cfg.sig } : null; }
  function warn(e) { if (window.console) console.warn('[TinyWolf dog saving]', e); }

  /* ---------- plan builder ---------- */
  function quizState() { try { var w = JSON.parse(sessionStorage.getItem('tw_quiz_v1') || 'null'); return w && w.s; } catch (e) { return null; } }
  function profileOf(s) { var m = s && s.result && String(s.result.url || '').match(/[?&]profile=([0-9a-f-]{36})/i); return m ? m[1] : null; }
  function note(id, html, tone) {
    var host = document.querySelector('.twq-res-head'); if (!host) return;
    var n = document.querySelector('[data-dogsync-note]');
    if (!n) {
      n = document.createElement('div'); n.setAttribute('data-dogsync-note', '');
      n.style.cssText = 'order:3;padding:18px 20px;border-radius:20px;font-size:15px;line-height:1.45;display:flex;flex-direction:column;gap:12px;align-items:flex-start';
      host.parentNode.insertBefore(n, host.nextSibling);
    }
    n.dataset.for = id;
    n.style.background = tone === 'ask' ? 'var(--white, #fff)' : 'var(--paper, #f6f1ea)';
    n.style.border = tone === 'ask' ? '1.5px solid var(--plum, #6b1f4f)' : '0';
    n.innerHTML = html;
  }
  function quizTick() {
    var s = quizState(), id = profileOf(s);
    var old = document.querySelector('[data-dogsync-note]');
    if (old && old.dataset.for !== id) old.remove();
    if (!id || !UUID.test(id) || done().indexOf('q:' + id) > -1) return;
    var name = String(s.name || 'your dog').trim(), email = String(s.email || '').trim().toLowerCase(), sg = signed();
    var body = null;
    if (sg) body = Object.assign({ profile_ids: [id] }, sg);
    else if (email && !cfg.loggedIn) body = { profile_ids: [id], email: email };
    markDone(['q:' + id]);
    if (!body) return;
    send(body).then(function (r) {
      var st = r && r.status;
      if (st === 'saved') note(id, '<span>Saved to your account. ' + esc(name) + '’s details are in <a href="' + esc(cfg.myDogs) + '" style="color:var(--plum);font-weight:600;text-decoration:underline">My dogs</a>.</span>');
      else if (st === 'created') note(id, '<span>We’ve saved ' + esc(name) + ' to an account for ' + esc(email) + '. Log in with that email anytime to see ' + esc(name) + ' in My dogs.</span>');
      else if (st === 'login_required') note(id, '<b style="font-size:17px">Looks like you have an account.</b><span>Log in to save ' + esc(name) + ' to it. You can still order straight away.</span><a class="btn btn-primary" href="' + esc(cfg.login) + '">Log in to save ' + esc(name) + '</a>', 'ask');
    }).catch(warn);
  }

  /* ---------- My dogs ---------- */
  function accountSync() {
    var sg = signed(); if (!sg) return;
    var have = [];
    try { var c = JSON.parse(document.querySelector('[data-twa-config]').textContent), d = c.dogs; if (typeof d === 'string') d = JSON.parse(d); d = Array.isArray(d) ? d : (d && d.dogs) || []; have = d.map(function (x) { return String(x.id); }); } catch (e) {}
    var local = [];
    try { local = JSON.parse(localStorage.getItem('tw_dogs_local') || '[]'); } catch (e) {}
    var ids = (Array.isArray(local) ? local : []).map(function (x) { return String(x && x.id || ''); })
      .filter(function (id) { return UUID.test(id) && have.indexOf(id) < 0 && done().indexOf('a:' + id) < 0; });
    if (!ids.length) return;
    markDone(ids.map(function (id) { return 'a:' + id; }));
    send(Object.assign({ profile_ids: ids }, sg)).then(function (r) {
      if (r && r.status === 'saved') {
        try { if (!sessionStorage.getItem('tw_dogsync_reloaded')) { sessionStorage.setItem('tw_dogsync_reloaded', '1'); location.reload(); } } catch (e) {}
      }
    }).catch(warn);
  }

  if (cfg.page === 'customize-your-plan') { quizTick(); setInterval(quizTick, 1500); }
  else if (cfg.page === 'my-dogs') accountSync();
})();
